import { FormatPrice } from '@/components/blocks/HDMPriceDisplay/FormatPrice';
import { useTitleMap } from '@/components/blocks/PromotionCard/parts/PromotionComponentMapping';
import { SwipeableDrawerHDM } from '@/components/blocks/PromotionCard/parts/SwipeableDrawerHDM';
import {
	msiSX,
	promoIconSX,
	separatorSx,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import {
	PDP_MSI_LOWER_ESPOT,
	PDP_MSI_MIDDLE_ESPOT,
	PDP_MSI_UPPER_ESPOT,
} from '@/components/content/ProductDetails/constants';
import {
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PROMOTION_TYPES,
} from '@/data/constants/promoIconConstants';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSettings } from '@/data/Settings';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';

import { useLocalization } from '@/data/Localization';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, CardMedia, Divider, Typography } from '@mui/material';
import { FC, useContext, useState } from 'react';

export const MSIDrawer: FC = () => {
	const productDetailNLS = useLocalization('HDMProductDetail');
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const msiDrawerTitle = useTitleMap('msi');
	const { selection, product: parentProduct } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	> &
		ReturnType<typeof useSkuListTable>;
	const product = selection?.sku ? selection?.sku : parentProduct;
	const { offer } = product?.productPrice || {};
	const months = 12;
	const price = offer ? offer / months : null;
	const handleOpenDrawerMsi = () => {
		setIsOpen((prevValue) => !prevValue);
	};

	const paymentMethod = useLocalization('Promotions');
	const { settings } = useSettings();
	const imageServerHostName = settings?.userData?.IMAGE_SERVER_HOSTNAME ?? '';

	return (
		<>
			<Divider sx={separatorSx} />
			<Box sx={msiSX.container} id="openMSIDetail" onClick={handleOpenDrawerMsi}>
				<Box sx={msiSX.iconContainer}>
					<CardMedia
						component="img"
						image={imageServerHostName + PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMOICON_MSI}
						sx={promoIconSX.msi}
						title={paymentMethod.Labels.Title.t()}
						className={setClassName(PROMOTION_TYPES.PROMOICON_MSI)}
					/>
				</Box>
				<Box sx={msiSX.textContainer}>
					<Box sx={msiSX.titleContainer}>
						<Typography variant="headingFeatured" component="span" sx={msiSX.msiText}>
							{paymentMethod.Labels.Description_4.t()}
						</Typography>

						<Typography variant="headingFeatured" component="span" sx={msiSX.availableText}>
							{paymentMethod.Labels.Available_msg.t()}
						</Typography>
					</Box>

					<Typography variant="bodySubText" component="span" sx={msiSX.priceText}>
						<FormatPrice price={price!} type="simple" />
					</Typography>

					<Typography variant="bodySubText" component="span" sx={msiSX.monthsTextContainer}>
						<Typography variant="bodySubText" component="span" sx={msiSX.perMonthsText}>
							{productDetailNLS.Promotions.MSI.PerMonth.t()}
						</Typography>{' '}
						<Typography variant="bodySubText" component="span" sx={msiSX.monthsText}>
							{productDetailNLS.Promotions.MSI.Month.t()}
						</Typography>
						<sup>†</sup>
					</Typography>
				</Box>
				<Box sx={msiSX.chevronIconContainer}>
					<ChevronRightIcon sx={msiSX.chevronIcon} />
				</Box>
			</Box>

			{isOpen ? (
				<SwipeableDrawerHDM // TODO: most of the functions use to open and close the component are not defined yet, this should be address in US
					isOpen={isOpen}
					setOpenDrawer={setIsOpen}
					variant={'msi'}
					title={msiDrawerTitle}
				>
					<Box sx={msiSX.msiEspot}>
						<EMarketingSpot
							id={PDP_MSI_UPPER_ESPOT}
							properties={{ emsName: PDP_MSI_UPPER_ESPOT }}
						/>
					</Box>
					<Box sx={msiSX.msiEspot}>
						<EMarketingSpot
							id={PDP_MSI_MIDDLE_ESPOT}
							properties={{ emsName: PDP_MSI_MIDDLE_ESPOT }}
						/>
					</Box>

					<Box sx={msiSX.msiEspot}>
						<EMarketingSpot
							id={PDP_MSI_LOWER_ESPOT}
							properties={{ emsName: PDP_MSI_LOWER_ESPOT }}
						/>
					</Box>
				</SwipeableDrawerHDM>
			) : null}
		</>
	);
};
